import { ErrorHandler, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InstanaService implements ErrorHandler {
  handleError(error: any) {
    window.ineum('reportError', error);

    // Continue to log caught errors to the console
    console.error(error);
  }
}
